<ng-template #content><ng-content select="[content]"></ng-content></ng-template>

<vi-card [footer]="false">
  <div
    title
    data-at-title
    *ngIf="title"
    class="title-panel flex flex-row justify-between items-center"
    [class.expandable]="isExpandable"
    (click)="toggleExpansion()"
  >
    <div class="title flex flex-row gap-[16px] justify-start items-center">
      <h3 class="flex-1">
        {{ title }}
      </h3>
      <ng-content select="[title]"></ng-content>
    </div>
    <div data-at-icons *ngIf="isExpandable" class="flex flex-row justify-center items-stretch">
      <mat-icon data-at-arrow-down *ngIf="!isExpanded">keyboard_arrow_down</mat-icon>
      <mat-icon data-at-arrow-up *ngIf="isExpanded">keyboard_arrow_up</mat-icon>
    </div>
  </div>
  <div
    body
    data-at-body
    *ngIf="isExpanded && isExpandable"
    class="body-panel"
    [class.no-title]="!title"
    [@toggle]
  >
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </div>
  <div body data-at-body *ngIf="!isExpandable" class="body-panel" [class.no-title]="!title">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </div>
</vi-card>
